import { render, staticRenderFns } from "./Intake.vue?vue&type=template&id=5a2e4d8d"
import script from "./Intake.vue?vue&type=script&lang=js"
export * from "./Intake.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports